<template>
  <div>
    <v-overlay
      v-model="showSuccessMessage"
      :scrim="true"
      opacity="0.3"
      persistent
      :z-index="9999"
    >
    </v-overlay>
    <transition name="fade-slide">
      <div v-if="showSuccessMessage && (successMessageExport || successMessageDelete)" class="success-toast">
        <img src="@/assets/mdi_success-bold.svg" alt="img" width="20" height="20" />
        <span v-if="successMessageExport" style="font-size: 14px; font-weight: 600;">
          {{ successMessageExport }}
        </span>
        <span v-if="successMessageDelete" style="font-size: 14px; font-weight: 600;">
          {{ successMessageDelete }}
        </span>
      </div>
    </transition>
    <v-container fluid>
      <v-card class="card2">
        <v-card-text>
          <v-row align="center">
            <!-- ส่วนค้นหา -->
             <v-col cols="12" md="6">
              <h2 style="font-weight: 600; color: #171717;">{{ $t('flowList') }}</h2>
            </v-col>

            <!-- ส่วนปุ่มการทำงาน -->
            <v-col cols="6" class="d-flex flex-wrap justify-end gap-2">
              <v-row align="center" justify="end" style="gap: 20px;">

                <!-- Create Button -->
                 <v-text-field
                  :placeholder="$t('flowName')"
                  hide-details
                  variant="plain"
                  clearable
                  class="search-input"
                  density="comfortable"
                  v-model="searchFlowName"
                  @keydown.enter="Search"
                >
                  <template #prepend-inner>
                    <img
                      class="search-icon"
                      src="@/assets/flowbite_search-outline.svg"
                      alt="Search"
                      width="20"
                      height="20"
                    />
                  </template>
                </v-text-field>
                <v-tooltip location="top" max-width="230px">
                  <template v-slot:activator="{ props }">
                    <button
                      v-bind="props"
                      id="button-create-flowlist"
                      type="button"
                      class="flow-add"
                      variant="elevated"
                      size="large"
                      rounded="xl"
                      @click="createFlow"
                    >
                      <img src="@/assets/ic_round-plus.svg" alt="img" width="20" height="20" />
                      <span style="color: #ffffff; font-size: 14px;">{{ $t("add") }}</span>
                    </button>
                  </template>
                  <span>{{ $t('createNewFlow') }}</span>
                </v-tooltip>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server
          v-model:options="options"
          :items-per-page="itemsPerPage"
          :items-length="searchTotalTable"
          :items="flows"
          :headers="headers"
          :loading="loading"
          class="pa-4"
        >
        <template v-slot:bottom>
          <div
            class="d-flex justify-space-between align-center px-4 py-2"
            style="width: 100%"
          >
            <div>{{ $t('totalResults') }} {{ searchTotalTable }}</div>

            <v-data-table-footer
              :items="[
                { text: '10', value: 10 },
                { text: '25', value: 25 },
                { text: '50', value: 50 },
                { text: '100', value: 100 },
                { text: 'All', value: -1 },
              ]"
              :page="options.page"
              :length="Math.ceil(searchTotalTable / itemsPerPage)"
            />
          </div>
        </template>
          <!-- No Data Template -->
          <template v-slot:no-data>
            <div class="no-data-container">
              <div class="no-data-content">
                <!-- Icon -->
                <v-icon size="64" color="grey-lighten-2" class="no-data-icon">
                  mdi-chart-timeline-variant-shimmer
                </v-icon>
                
                <!-- Message -->
                <div class="no-data-text">
                  <h3 class="no-data-title">{{ $t('noFlowsFound') }}</h3>
                  <p class="no-data-subtitle">{{ $t('_noFlowsAvailable') }}</p>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td style="text-align: left">{{ item.number }}</td>
              <td style="text-align: left">{{ item.name }}</td>
              <td style="text-align: left">{{ item.createBy }}</td>
              <td style="text-align: left">{{ formatDateTime(item.createDate) }}</td>
              <td class="text-center">
                <div class="action-group">
                  <v-btn
                    id="button-view-flowlist"
                    variant="text"
                    density="comfortable"
                    @click="viewFlow(item)"
                    class="action-btn view-btn"
                    icon
                  >
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/images/eyedetail.svg"
                          alt="img"
                          width="20"
                          height="20"
                          style="cursor: pointer; margin-left: 4px;"
                        />
                      </template>
                      <span>{{ $t('viewFlow') }}</span>
                    </v-tooltip>
                  </v-btn>

                  <v-btn
                    id="button-edit-flowlist"
                    variant="text"
                    density="comfortable"
                    @click="editFlow(item)"
                    class="action-btn edit-btn"
                    icon
                  >
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/Edit.svg"
                          alt="img"
                          width="20"
                          height="20"
                          style="cursor: pointer; margin-left: 4px;"
                        />
                      </template>
                      <span>{{ $t('editFlow') }}</span>
                    </v-tooltip>
                  </v-btn>
                  
                  <v-btn
                    id="button-export-flowlist"
                    variant="text"
                    density="comfortable"
                    @click="exportFlow(item)"
                    class="action-btn download-btn"
                    icon
                  >
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/images/Export.svg"
                          alt="img"
                          width="20"
                          height="20"
                          style="cursor: pointer; margin-left: 4px;"
                        />
                      </template>
                      <span>{{ $t('exportFlow') }}</span>
                    </v-tooltip>
                  </v-btn>

                  <div class="action-divider"></div>
                  
                  <v-btn
                    id="button-delete-flowlist"
                    variant="text"
                    density="comfortable"
                    @click="deleteFlow(item)"
                    class="action-btn delete-btn"
                    icon
                    :disabled="!canDeleteFlow(item)"
                  >
                  <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/Group.svg"
                          alt="img"
                          width="20"
                          height="20"
                          style="cursor: pointer; margin-left: 4px;"
                        />
                      </template>
                      <span>{{ canDeleteFlow(item) ? $t('deleteFlow') : $t('_onlyDeleteOwnFlows') }}</span>
                    </v-tooltip>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="deleteDialog" max-width="500px" persistent>
        <v-card class="delete-dialog">
            <v-card-title class="delete-dialog-header">
              <div class="header-text">
                <h3 class="dialog-title">{{ $t('deleteConfirmation') }}</h3>
              </div>
            </v-card-title>

            <v-card-text class="delete-dialog-content">
                <div class="confirmation-content">
                    <!-- Flow Info Display -->
                    <div class="flow-info-display">
                        <img src="@/assets/code-branch-delete.svg" alt="Flow Icon" width="30" height="30" class="flow-icon" />
                        <div class="flow-details">
                            <div class="flow-name">{{ selectedFlow?.name }}</div>
                            <div class="flow-meta">
                                <span class="meta-item">
                                    <img src="@/assets/user-3-line.svg" alt="user icon" width="14" height="14" />
                                    {{ selectedFlow?.createBy }}
                                </span>
                                <span class="meta-item">
                                    <img src="@/assets/calendarDate.svg" alt="calendar icon" width="14" height="14" />
                                    {{ formatDateTime(selectedFlow?.createDate) }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <!-- Confirmation Text -->
                    <div class="confirmation-text">
                        {{ $t('_confirmDeleteFlow') }}
                    </div>

                    <!-- Warning Message -->
                    <div class="warning-alert">
                        <div class="warning-icon">
                            <img src="@/assets/Frame 191.svg" alt="Warning Icon" width="24" height="24" />
                        </div>
                        <div class="warning-text">
                            {{ $t('_warningDeleteFlowPermanent') }}
                        </div>
                    </div>

                </div>
            </v-card-text>

            <v-card-actions class="delete-dialog-actions">
              <button type="button" @click="deleteDialog = false"  variant="outlined" class="cancel-btn">{{ $t('cancel') }}</button>
              <button type="button" @click="confirmDelete" color="error" variant="elevated" class="delete-btn-dialog">
                  <img src="@/assets/heroicons_trash-solid.svg" alt="img" width="17" height="22" class="mr-2">
                  <p style="color: #ffffff; font-size: 14px; font-weight: 500;">{{ $t('delete') }}</p>
              </button>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- Success/Error Snackbar -->
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      timeout="3000"
      top
    >
      {{ snackbarMessage }}
      <v-btn text @click="snackbar = false">
        {{ $t('close') }}
      </v-btn>
    </v-snackbar>
    
    <!-- Success Dialog -->
    <v-dialog v-model="successDialog" max-width="500" persistent>
      <v-card class="success-dialog">
        <v-card-title class="success-dialog-header">
          <div class="success-header-content">
            <v-icon class="success-icon" size="40">mdi-check-circle</v-icon>
            <span class="success-title">{{ $t('deletedSuccessfully') }}</span>
          </div>
        </v-card-title>
        
        <v-card-text class="success-dialog-content">
          <div class="success-message">
            {{ successMessage }}
          </div>
          
          <div class="success-details">
            <div class="success-detail-item">
              <v-icon size="18" class="mr-2">mdi-chart-timeline-variant</v-icon>
              <span>{{ $t('Flow') }}: {{ deletedFlowName }}</span>
            </div>
            <div class="success-detail-item">
              <v-icon size="18" class="mr-2">mdi-clock-outline</v-icon>
              <span>{{ formatDateTime(new Date()) }}</span>
            </div>
            <div class="success-detail-item">
              <v-icon size="18" class="mr-2">mdi-delete-circle</v-icon>
              <span>{{ $t('operation') }}: {{ $t('delete') }}</span>
            </div>
          </div>
        </v-card-text>
        
        <v-card-actions class="success-dialog-actions">
          <v-spacer></v-spacer>
          <v-btn 
            @click="successDialog = false" 
            color="success" 
            variant="elevated"
            class="success-ok-btn"
          >
            <v-icon class="mr-2">mdi-check</v-icon>
            {{ $t('ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  name: "FlowList",
  computed: {
    currentUser() {
      return this.$store.state.username;
    },
    userRoleId() {
      return this.roleId;
    },
    headers() {
      return [
        { title: this.$t('no'), key: 'number', align: 'left', sortable: false, width: '80px' },
        { title: this.$t('name'), key: 'name', align: 'left', sortable: true },
        { title: this.$t('createdBy'), key: 'createBy', align: 'left', sortable: true },
        { title: this.$t('createdDate'), key: 'createDate', align: 'left', sortable: true },
        { title: this.$t('manage'), key: 'actions', align: 'center', sortable: false, width: '200px' },
      ];
    },
  },
  data() {
    const roleIdValue = Cookies.get("roleId");
    const roleUserOrOperator = roleIdValue == "2" ? "User" : "Operator";
    const roleAdminOrLower = roleIdValue == "1" ? "Admin" : roleUserOrOperator;
    const roleLabel = roleIdValue == "0" ? "Super admin" : roleAdminOrLower;
    return {
      showSuccessMessage: false,
      successMessageExport: '',
      successMessageDelete: '',
      _deleteToastTimer: null,
      flagNav: true,
      today: new Date().toLocaleDateString(),
      searchFlowName: '',
      flows: [],
      loading: false,
      deleteDialog: false,
      selectedFlow: null,
      snackbar: false,
      snackbarMessage: '',
      snackbarColor: 'success',
      role: roleLabel,
      roleId: roleIdValue,
      
      // Add success dialog properties
      successDialog: false,
      successMessage: '',
      deletedFlowName: '',

      // Table configuration
      options: {},
      itemsPerPage: 10,
      searchTotalTable: 0,
    }
  },
  watch: {
    options: {
      handler() {
        this.loadFlows()
      },
      deep: true
    }
  },
  mounted() {
    this.loadFlows()
  },
  methods: {
    // Check if current user can delete the flow
    canDeleteFlow(flow) {
      const isCreator = this.currentUser === flow.createBy;
      const isSuperAdmin = this.userRoleId === '0' || this.userRoleId === '1';
      
      return isCreator || isSuperAdmin;
    },

    async loadFlows() {
      this.loading = true
      try {
        const { page, itemsPerPage, sortBy } = this.options
        const requestData = {
          page: page || 1,
          perPage: itemsPerPage || 10,
          name: this.searchFlowName || null,
          sortBy: sortBy?.[0]?.key || null,
          sortDesc: sortBy?.[0]?.order === 'desc' || false
        }

        this.$call.GetTableFlowManagement(requestData, 
          (response) => {
            if (response.status === 0) {
              this.flows = response.data.data
              this.searchTotalTable = response.data.total
            } else {
              this.showError(this.$t('_failedToLoadFlows'))
            }
            this.loading = false
          },
          (error) => {
            console.error('Error loading flows:', error)
            this.showError(this.$t('_failedToLoadFlows'))
            this.loading = false
          }
        )
      } catch (error) {
        console.error('Error loading flows:', error)
        this.showError(this.$t('_failedToLoadFlows'))
        this.loading = false
      }
    },

    Search() {
      this.options = { ...this.options, page: 1 }
      this.loadFlows()
    },

    createFlow() {
      this.$router.push('/FlowCreator')
    },

    viewFlow(flow) {
      this.$router.push(`/FlowCreator?id=${flow.id}&mode=view`)
    },

    editFlow(flow) {
      this.$router.push(`/FlowCreator?id=${flow.id}&mode=edit`)
    },

    async exportFlow(flow) {
      this.$call.GetFlowById(flow.id,
        (response) => {
          if (response.status === 0) {
            const flowData = response.data
            
            // Convert to flat structure format like Flow.vue
            const flatNodes = this.convertToFlatStructure(flowData.flowDetails || [])
            
            const exportData = {
              name: flowData.name,
              nodes: flatNodes,
              metadata: {
                exportedAt: new Date().toISOString(),
                nodeCount: flatNodes.length,
                originalId: flowData.id
              }
            }

            const dataStr = JSON.stringify(exportData, null, 2)
            const dataBlob = new Blob([dataStr], { type: 'application/json' })
            
            const link = document.createElement('a')
            link.href = URL.createObjectURL(dataBlob)
            link.download = `Flow_Config_${flow.name.replace(/\s+/g, '_')}.json`
            link.click()

            this.successMessageExport = this.$t('_flowExportedSuccessfully');
            this.showSuccessMessage = true;
            clearTimeout(this._deleteToastTimer);
            this._deleteToastTimer = setTimeout(() => {
              this.showSuccessMessage = false;
            }, 2000);
          } else {
            this.showError(this.$t('_failedToGetFlowData'))
          }
        },
        (error) => {
          console.error('Export error:', error)
          this.showError(this.$t('_failedToExportFlow'))
        }
      )
    },
    beforeUnmount() {
      clearTimeout(this._deleteToastTimer);
    },

    deleteFlow(flow) {
      // Double check permission before showing dialog
      if (!this.canDeleteFlow(flow)) {
        this.showError(this.$t('_onlyDeleteOwnFlows'));
        return;
      }
      
      this.selectedFlow = flow
      this.deleteDialog = true
    },

    async confirmDelete() {
      // Final permission check before deletion
      if (!this.canDeleteFlow(this.selectedFlow)) {
        this.showError(this.$t('_notAuthorizedDeleteFlow'));
        this.deleteDialog = false;
        this.selectedFlow = null;
        return;
      }

      this.$call.DeleteFlow(this.selectedFlow.id,
        (response) => {
          if (response.status === 0) {
            this.deletedFlowName = this.selectedFlow.name;
            this.successMessageDelete = this.$t('_flowDeletedSuccessfully');
            this.showSuccessMessage = true;
            clearTimeout(this._deleteToastTimer);
            this._deleteToastTimer = setTimeout(() => {
              this.showSuccessMessage = false;
              this.successMessageDelete = '';
            }, 2000);
            this.loadFlows(); // Reload the list
          } else {
            this.showError(this.$t('_failedToDeleteFlow'));
          }
          this.deleteDialog = false;
          this.selectedFlow = null;
        },
        (error) => {
          console.error('Delete error:', error);
          this.showError(this.$t('_failedToDeleteFlow'));
          this.deleteDialog = false;
          this.selectedFlow = null;
        }
      );
    },
    showSuccessDialog(message) {
      this.successMessage = message;
      this.successDialog = true;
      
      // Auto close after 3 seconds
      setTimeout(() => {
        this.successDialog = false;
      }, 3000);
    },

    // Convert flowDetails to flat structure format (like Flow.vue)
    convertToFlatStructure(flowDetails) {
      if (!flowDetails || !Array.isArray(flowDetails)) {
        return []
      }

      // Parse flowDetails if they're strings
      const parsedFlowDetails = flowDetails.map(item => {
        if (typeof item === 'string') {
          try {
            return JSON.parse(item)
          } catch (e) {
            console.error(e);
            // JSON invalid, keep original string item
            return item
          }
        }
        return item
      })

      // Create flat nodes with targets structure
      return parsedFlowDetails.map(node => {
        // Parse data and position if they're strings
        let data = node.data
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data)
          } catch (e) {
            console.error(e);
            // JSON invalid, fall back to default label data
            data = { label: node.nodeType || 'Unknown' }
          }
        }

        let position = node.position
        if (typeof position === 'string') {
          try {
            position = JSON.parse(position)
          } catch (e) {
            console.error(e);
            // JSON invalid, fall back to default position
            position = { x: 0, y: 0 }
          }
        }

        let targets = node.targets
        if (typeof targets === 'string') {
          try {
            targets = JSON.parse(targets)
          } catch (e) {
            console.error(e);
            // JSON invalid, fall back to empty targets
            targets = []
          }
        }

        return {
          id: node.id,
          nodeType: node.nodeType,
          position: position,
          data: data,
          targets: targets || []
        }
      })
    },

    formatDateTime(dateString) {
      if (!dateString) return '-'
      
      try {
        // Handle different date formats from backend
        let date
        if (dateString.includes('T') && !dateString.includes('Z') && !dateString.includes('+')) {
          // Add 'Z' to indicate UTC time
          date = new Date(dateString + 'Z')
        } else {
          date = new Date(dateString)
        }
        
        // Check if date is valid
        if (Number.isNaN(date.getTime())) {
          return dateString // Return original if parsing fails
        }
        
        // Format as dd/MM/yyyy HH:mm:ss in local time
        // JavaScript automatically converts UTC to local timezone
        const day = String(date.getDate()).padStart(2, '0')
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const year = date.getFullYear()
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        const seconds = String(date.getSeconds()).padStart(2, '0')
        
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
      } catch (error) {
        console.error('Date formatting error:', error)
        return dateString // Return original if error occurs
      }
    },

    showSuccess(message) {
      this.snackbarMessage = message
      this.snackbarColor = 'success'
      this.snackbar = true
    },

    showError(message) {
      this.snackbarMessage = message
      this.snackbarColor = 'error'
      this.snackbar = true
    },

    showInfo(message) {
      this.snackbarMessage = message
      this.snackbarColor = 'info'
      this.snackbar = true
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}

.card2 {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  margin-top: 1rem;
}

.header-title {
  border-radius: 16px !important;
  margin-bottom: 1rem;
}

.search-panel {
  border-radius: 12px !important;
  background: transparent;
}

.action-controls {
  display: flex;
  align-items: center;
  gap: 16px;
}

.control-btn {
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  height: 48px !important;
  border-radius: 12px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.control-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15) !important;
}
.create-btn {
  background: linear-gradient(135deg, #0071eb 0%, #0056b3 100%) !important;
  color: white !important;
}

.action-group {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

.action-btn {
  border-radius: 8px !important;
  transition: all 0.2s ease !important;
}

.action-btn:hover {
  transform: scale(1.1) !important;
}

.view-btn:hover {
  background: #fddecb !important;
  color: #955400 !important;
}

/* Table styling */
:deep(.v-data-table) {
  border-radius: 12px !important;
}

:deep(.v-data-table__wrapper) {
  border-radius: 12px !important;
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%) !important;
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  font-weight: 600 !important;
  color: #374151 !important;
  border-bottom: 2px solid #e5e7eb !important;
}

:deep(.v-data-table__tbody tr:hover) {
  background: rgba(59, 130, 246, 0.02) !important;
}

/* No Data Template */
.no-data-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  padding: 40px 20px;
}

.no-data-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 400px;
  gap: 24px;
}

.no-data-icon {
  opacity: 0.6;
  transition: opacity 0.3s ease;
}

.no-data-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.no-data-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #424242;
  margin: 0;
  letter-spacing: 0.025em;
}

.no-data-subtitle {
  font-size: 0.9rem;
  color: #757575;
  margin: 0;
  font-weight: 400;
  line-height: 1.4;
}

/* Responsive design */
@media (max-width: 768px) {
  .action-controls {
    flex-direction: column;
    width: 100%;
    gap: 8px;
  }
  
  .control-btn {
    width: 100% !important;
    min-width: auto !important;
  }
}

/* Disabled action button styles */
.action-btn.delete-btn:disabled {
  cursor: not-allowed !important;
  pointer-events: none !important;
  color: #686868 !important;
  background-color: #ffe3e3 !important;
}

.action-btn:disabled .v-icon {
  color: #c3afaf !important;
}

/* Delete Dialog Styles */
.delete-dialog {
    border-radius: 20px !important;
    overflow: hidden;
    background-color: #ffffff !important;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2), 0 8px 32px rgba(0, 0, 0, 0.1) !important;
    animation: slideInScale 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.delete-dialog-header {
    background: linear-gradient(135deg, #ffffff 0%, #fff5f2 100%) !important;
    color: #171717 !important;
    padding: 24px 28px 20px !important;
    border-radius: 0 !important;
}

.delete-dialog-header .header-content {
    display: flex;
    align-items: center;
    gap: 20px;
}

.warning-icon-container {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(10px);
}

.header-text {
    flex: 1;
}

.dialog-title {
    font-size: 18px;
    font-weight: 700;
    margin: 0 0 4px 0;
    color: #c30000 !important;
}

.dialog-subtitle {
    font-size: 0.9rem;
    opacity: 0.9;
    margin: 0;
    color: rgba(255, 255, 255, 0.8);
}

.delete-dialog-content {
    padding: 28px !important;
    background: #ffffff !important;
}

.confirmation-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.flow-info-display {
    display: flex;
    align-items: center;
    padding: 12px;
    background: #ffffff !important;
    border-radius: 12px;
    border: 1px solid #c9c9c9 !important;
    gap: 16px;
}

.flow-details {
    flex: 1;
}

.flow-name {
    font-size: 1.25rem;
    font-weight: 600;
    color: #1a202c;
    margin-bottom: 8px;
    line-height: 1.2;
}

.flow-meta {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
}

.meta-item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 0.85rem;
    color: #6b7280;
}

.warning-alert {
  display: flex;
  background: #fff7ed !important;
  color: #996417 !important;
  font-weight: 500 !important;
  padding: 8px;
  border-radius: 12px !important;
  gap: 12px;
}

.warning-icon {
    width: 15%;
}

.warning-text {
    font-size: 16px;
    line-height: 1.4;
}

.confirmation-text {
    font-size: 16px;
    font-weight: 500;
    color: #171717;
    text-align: left;
}

.delete-dialog-actions {
    padding: 20px 28px 28px !important;
    background: #ffffff !important;
    gap: 12px;
}

.cancel-btn {
    border-width: 1px;
    border-style: solid;
    border-radius: 12px !important;
    border-color: #d1d5db !important;
    color: #6b7280 !important;
    font-weight: 600 !important;
    min-width: 120px !important;
    height: 48px !important;
    transition: all 0.2s ease !important;
}

.cancel-btn:hover {
    border-color: #9ca3af !important;
    background: rgba(156, 163, 175, 0.1) !important;
    transform: translateY(-1px);
}

.delete-btn-dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px !important;
    font-weight: 600 !important;
    min-width: 140px !important;
    height: 48px !important;
    background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%) !important;
    box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3) !important;
    transition: all 0.2s ease !important;
}

.delete-btn-dialog:hover {
    background: linear-gradient(135deg, #b91c1c 0%, #991b1b 100%) !important;
    box-shadow: 0 6px 16px rgba(220, 38, 38, 0.4) !important;
    transform: translateY(-2px);
}

.delete-btn-dialog:active {
    transform: translateY(0);
}

/* Responsive design */
@media (max-width: 600px) {
    .delete-dialog-header .header-content {
        flex-direction: column;
        text-align: center;
        gap: 16px;
    }
    
    .flow-info-display {
        flex-direction: column;
        text-align: center;
        gap: 16px;
    }
    
    .flow-meta {
        justify-content: center;
    }
    
    .delete-dialog-actions {
        flex-direction: column;
        gap: 12px;
    }
}

/* Animation for dialog appearance */
@keyframes slideInScale {
    from {
        opacity: 0;
        transform: scale(0.9) translateY(-20px);
    }
    to {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}/* Success Dialog Styles */
.success-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
  animation: successSlideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.success-dialog-header {
  background: linear-gradient(135deg, #0c8731 0%, #047834 100%);
  color: white;
  padding: 24px !important;
  text-align: center;
  border-bottom: none;
}

.success-header-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.success-icon {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  padding: 12px;
  animation: successPulse 2s infinite;
}

@keyframes successPulse {
  0% { 
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }
  50% { 
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }
  100% { 
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}
.search-input {
  max-width: 280px;
  background: white;
  border: 1px solid #C9C9C9;
  border-radius: 12px;
}
.search-input :deep(.v-field__field) {
  align-items: center;
}
.search-input :deep(input) {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  line-height: 20px;
  min-height: 40px;
  display: flex;
  align-items: center;
  font-size: 13px;
}
.search-icon {
  margin-left: 12px;
  margin-top: -4px;
  height: 18px;
}
.flow-add {
  display: flex;
  flex-direction: row;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  border-radius: 12px;
  width: 108px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 12px;
  margin-right: 16px;
}
.flow-add:hover {
  background: linear-gradient(100deg, #F36243 0%, #FF8E7A 100%) !important;
}
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
.success-toast {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(100deg, #1d863c 0%, #135928 100%) !important;
  color: #ffffff;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  z-index: 2100;
  width: 50%;
  max-width: 900px;
  min-width: 320px;
  justify-content: center;
  padding: 12px;
  border: 1px solid #ffffff;
  gap: 20px;
  margin-top: 140px;
}
.delete-confirm-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px !important;
  width: 120px;
  background: #C30000;
}

.success-title {
  font-size: 1.5rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.success-dialog-content {
  padding: 32px 24px !important;
  text-align: center;
  background: #fafafa;
}

.success-message {
  font-size: 1.1rem;
  font-weight: 600;
  color: #047857;
  margin-bottom: 24px;
  line-height: 1.5;
}

.success-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: white;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid rgba(16, 185, 129, 0.1);
}

.success-detail-item {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  color: #374151;
  font-weight: 500;
}

.success-detail-item .v-icon {
  color: #10b981;
}

.success-dialog-actions {
  padding: 20px 24px !important;
  background: white;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.success-ok-btn {
  height: 44px !important;
  padding: 0 24px !important;
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  background: linear-gradient(135deg, #10b943 0%, #047834 100%);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.success-ok-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 24px rgba(16, 185, 129, 0.4) !important;
}

.success-ok-btn:active {
  transform: translateY(0) !important;
}

/* Animation for dialog entrance */
@keyframes successSlideIn {
  from {
    opacity: 0;
    transform: scale(0.8) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

</style>
